/* Home V2: ch 07 — four chalkboard boards on one rail. No longer scroll-driven:
   a Previous / Next control advances the deck, dots jump to a board, and if the
   reader sits still for four seconds the boards advance on their own — the
   moment they touch anything (button, dot or the rail) the auto-advance stops
   for good. Auto-advance only starts once the rail is on screen. Reduced-motion
   (PEHomeV2.reduce, with a local fallback) disables the idle auto-advance. No
   PEHomeV2 scroll registration — this component is click-driven. */
(function () {
  'use strict';

  var sectionEl = document.getElementById('pe-method');
  var railEl = document.getElementById('hv2Rail');
  if (!sectionEl || !railEl) { return; }

  var reduce = (window.PEHomeV2 && window.PEHomeV2.reduce) ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function qa(sel) { return Array.prototype.slice.call(sectionEl.querySelectorAll(sel)); }

  var boards = qa('.hv2-board');
  var bDots  = qa('.b-dot');
  var bStory = qa('.b-story b');
  var bNext  = document.getElementById('hv2BNext');
  var bPrev  = document.getElementById('hv2BPrev');
  var bIdle  = document.getElementById('hv2BIdle');
  if (!boards.length) { return; }

  var bAt = 0, bTimer = null, bAuto = true, bSeen = false;

  function layoutBoards() {
    var spine = parseFloat(getComputedStyle(railEl).getPropertyValue('--spine')) || 20;
    var w = railEl.offsetWidth || 1200;
    for (var i = 0; i < boards.length; i++) {
      var x = i <= bAt ? i * spine : w + 60;
      boards[i].style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      boards[i].style.setProperty('--dim', (i < bAt ? Math.min(0.5, (bAt - i) * 0.24) : 0).toFixed(3));
      boards[i].setAttribute('aria-hidden', i === bAt ? 'false' : 'true');
    }
    for (var d = 0; d < bDots.length; d++) { bDots[d].classList.toggle('is-on', d === bAt); }
    for (var t = 0; t < bStory.length; t++) { bStory[t].classList.toggle('is-on', t <= bAt); }
    if (bPrev) { bPrev.disabled = bAt === 0; }
    if (bNext) {
      bNext.textContent = '';
      bNext.append('Next ');
      var arw = document.createElement('span');
      arw.className = 'b-next-arw'; arw.setAttribute('aria-hidden', 'true'); arw.textContent = '→';
      bNext.appendChild(arw);
      if (bIdle) { bNext.appendChild(bIdle); }
      bNext.disabled = bAt === boards.length - 1;
    }
  }

  function goBoard(i, byUser) {
    bAt = Math.max(0, Math.min(boards.length - 1, i));
    if (byUser) { bAuto = false; stopIdle(); }
    layoutBoards();
    if (bAuto) { armIdle(); }
  }

  function stopIdle() {
    if (bTimer) { clearTimeout(bTimer); bTimer = null; }
    if (bIdle) { bIdle.classList.remove('is-running'); }
  }

  function armIdle() {
    stopIdle();
    if (!bAuto || reduce || bAt >= boards.length - 1) { return; }
    if (bIdle) { void bIdle.offsetWidth; bIdle.classList.add('is-running'); }
    bTimer = setTimeout(function () { if (bAuto) { goBoard(bAt + 1, false); } }, 4000);
  }

  if (bNext) { bNext.addEventListener('click', function () { goBoard(bAt + 1, true); }); }
  if (bPrev) { bPrev.addEventListener('click', function () { goBoard(bAt - 1, true); }); }
  bDots.forEach(function (dot) {
    dot.addEventListener('click', function () { goBoard(+dot.dataset.goB, true); });
  });

  railEl.addEventListener('pointerdown', function () { bAuto = false; stopIdle(); });

  /* auto-advance only starts once the boards are actually on screen */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (x.isIntersecting && !bSeen) { bSeen = true; armIdle(); }
        else if (!x.isIntersecting) { stopIdle(); }
      });
    }, { threshold: 0.45 }).observe(railEl);
  }

  layoutBoards();

  /* re-place the boards when the rail width changes */
  var boardsResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(boardsResizeTimer);
    boardsResizeTimer = setTimeout(layoutBoards, 140);
  });
})();
